export default __webpack_public_path__ + "static/media/reset.8ae4e717.svg";